/* ========== ~~~~~~~~~~ PAUSE STATUS : ACTIONS ~~~~~~~~~~ ========== */
// ACTION
// utilized by reducers as a call to action to perform some kind of update to application state
// utilized in "_container" components and reducers



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export const STORE_PAUSED_STATE = "STORE_PAUSED_STATE";
export const CLEAR_PAUSED_STATE = "CLEAR_PAUSED_STATE";

export const storePausedState = pauseState => ({
    type: STORE_PAUSED_STATE,
    pauseState
});

export const clearPausedState = stateId => ({
    type: CLEAR_PAUSED_STATE,
    stateId
});